/**
 * Transform booking parts into a a group of refundable passenger items for an activity.
 */
export function transformRefundableGroupsActivity(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']) {
    const apiBooking = response?.booking;
    if (!apiBooking) {
        return [];
    }

    return bookingParts
        .filter(bp => bp.objectType === 'Activity')
        .reduce<RefundableGroupActivity[]>((list, bookingPart) => {
            assignActivity(list, bookingPart, apiBooking);
            return list;
        }, []);
}

/**
 *
 */
function assignActivity(
    list: RefundableGroupActivity[],
    activity: ApiSchema['Activity'],
    apiBooking: ApiSchema['Booking'],
) {
    const type = 'Activity';
    const id = activity.activityId ?? '';
    const refundable = transformRefundableActivity(activity, apiBooking);

    let refundableGroup = list
        .filter(p => p.type === type)
        .find(p => p.id === id);
    if (!refundableGroup) {
        refundableGroup = {
            id,
            type,
            refundables: [],
        } satisfies RefundableGroupActivity;
        list.push(refundableGroup);
    }

    refundableGroup.refundables.push(refundable);
}
